var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1139,
    height: 534,
    viewBox: "0 0 1139 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1001.02 2.09415H1003.73V534H1001.02V2.09415Z",
    fill: "url(#paint0_linear_207_210)",
    fillOpacity: 0.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.71 2.09415H354.416V534H351.71V2.09415Z",
    fill: "url(#paint1_linear_207_210)",
    fillOpacity: 0.03
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M676.366 2.09415H679.071V534H676.366V2.09415Z",
    fill: "url(#paint2_linear_207_210)",
    fillOpacity: 0.03
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0546 2.09415H29.7601V534H27.0546V2.09415Z",
    fill: "url(#paint3_linear_207_210)",
    fillOpacity: 0.03
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M838.694 2.09415H841.399V534H838.694V2.09415Z",
    fill: "url(#paint4_linear_207_210)",
    fillOpacity: 0.03
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.382 2.09415H192.088V534H189.382V2.09415Z",
    fill: "url(#paint5_linear_207_210)",
    fillOpacity: 0.03
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M514.038 2.09415H516.743V534H514.038V2.09415Z",
    fill: "url(#paint6_linear_207_210)",
    fillOpacity: 0.03
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.13 2.09415H1057.84V534H1055.13V2.09415Z",
    fill: "url(#paint7_linear_207_210)",
    fillOpacity: 0.03
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M405.819 2.09415H408.525V534H405.819V2.09415Z",
    fill: "url(#paint8_linear_207_210)",
    fillOpacity: 0.03
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M730.475 2.09415H733.18V534H730.475V2.09415Z",
    fill: "url(#paint9_linear_207_210)",
    fillOpacity: 0.03
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1639 2.09415H83.8694V534H81.1639V2.09415Z",
    fill: "url(#paint10_linear_207_210)",
    fillOpacity: 0.03
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M892.803 2.09415H895.508V534H892.803V2.09415Z",
    fill: "url(#paint11_linear_207_210)",
    fillOpacity: 0.03
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M243.492 2.09415H246.197V534H243.492V2.09415Z",
    fill: "url(#paint12_linear_207_210)",
    fillOpacity: 0.03
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M568.147 2.09415H570.853V534H568.147V2.09415Z",
    fill: "url(#paint13_linear_207_210)",
    fillOpacity: 0.03
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.24 2.09415H1111.95V534H1109.24V2.09415Z",
    fill: "url(#paint14_linear_207_210)",
    fillOpacity: 0.03
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M459.929 2.09415H462.634V534H459.929V2.09415Z",
    fill: "url(#paint15_linear_207_210)",
    fillOpacity: 0.03
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M784.584 2.09415H787.29V534H784.584V2.09415Z",
    fill: "url(#paint16_linear_207_210)",
    fillOpacity: 0.03
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M135.273 2.09415H137.979V534H135.273V2.09415Z",
    fill: "url(#paint17_linear_207_210)",
    fillOpacity: 0.03
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M946.912 2.09415H949.618V534H946.912V2.09415Z",
    fill: "url(#paint18_linear_207_210)",
    fillOpacity: 0.03
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M297.601 2.09415H300.306V534H297.601V2.09415Z",
    fill: "url(#paint19_linear_207_210)",
    fillOpacity: 0.03
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M622.257 2.09415H624.962V534H622.257V2.09415Z",
    fill: "url(#paint20_linear_207_210)",
    fillOpacity: 0.03
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.08 2.09415H1030.78V534H1028.08V2.09415Z",
    fill: "url(#paint21_linear_207_210)",
    fillOpacity: 0.03
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 2.09415H381.47V534H378.765V2.09415Z",
    fill: "url(#paint22_linear_207_210)",
    fillOpacity: 0.03
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M703.42 2.09415H706.126V534H703.42V2.09415Z",
    fill: "url(#paint23_linear_207_210)",
    fillOpacity: 0.03
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1093 2.09415H56.8147V534H54.1093V2.09415Z",
    fill: "url(#paint24_linear_207_210)",
    fillOpacity: 0.03
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M865.748 2.09415H868.454V534H865.748V2.09415Z",
    fill: "url(#paint25_linear_207_210)",
    fillOpacity: 0.03
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M216.437 2.09415H219.143V534H216.437V2.09415Z",
    fill: "url(#paint26_linear_207_210)",
    fillOpacity: 0.03
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M541.093 2.09415H543.798V534H541.093V2.09415Z",
    fill: "url(#paint27_linear_207_210)",
    fillOpacity: 0.03
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.19 2.09415H1084.89V534H1082.19V2.09415Z",
    fill: "url(#paint28_linear_207_210)",
    fillOpacity: 0.03
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M432.874 2.09415H435.58V534H432.874V2.09415Z",
    fill: "url(#paint29_linear_207_210)",
    fillOpacity: 0.03
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M757.53 2.09415H760.235V534H757.53V2.09415Z",
    fill: "url(#paint30_linear_207_210)",
    fillOpacity: 0.03
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.219 2.09415H110.924V534H108.219V2.09415Z",
    fill: "url(#paint31_linear_207_210)",
    fillOpacity: 0.03
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M919.857 2.09415H922.563V534H919.857V2.09415Z",
    fill: "url(#paint32_linear_207_210)",
    fillOpacity: 0.03
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M270.546 2.09415H273.252V534H270.546V2.09415Z",
    fill: "url(#paint33_linear_207_210)",
    fillOpacity: 0.03
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M595.202 2.09415H597.907V534H595.202V2.09415Z",
    fill: "url(#paint34_linear_207_210)",
    fillOpacity: 0.03
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 2.09415H1139V534H1136.29V2.09415Z",
    fill: "url(#paint35_linear_207_210)",
    fillOpacity: 0.03
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M486.983 2.09415H489.689V534H486.983V2.09415Z",
    fill: "url(#paint36_linear_207_210)",
    fillOpacity: 0.03
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M811.639 2.09415H814.344V534H811.639V2.09415Z",
    fill: "url(#paint37_linear_207_210)",
    fillOpacity: 0.03
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.328 2.09415H165.033V534H162.328V2.09415Z",
    fill: "url(#paint38_linear_207_210)",
    fillOpacity: 0.03
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M973.967 2.09415H976.672V534H973.967V2.09415Z",
    fill: "url(#paint39_linear_207_210)",
    fillOpacity: 0.03
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M324.656 2.09415H327.361V534H324.656V2.09415Z",
    fill: "url(#paint40_linear_207_210)",
    fillOpacity: 0.03
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M649.311 2.09415H652.017V534H649.311V2.09415Z",
    fill: "url(#paint41_linear_207_210)",
    fillOpacity: 0.03
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.09415H2.70546V534H0V2.09415Z",
    fill: "url(#paint42_linear_207_210)",
    fillOpacity: 0.03
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 230.353V232.447L6.94374e-05 232.447L6.95556e-05 230.353L1136.29 230.353Z",
    fill: "url(#paint43_linear_207_210)",
    fillOpacity: 0.03
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 481.647V483.741L5.52462e-05 483.741L5.53645e-05 481.647L1136.29 481.647Z",
    fill: "url(#paint44_linear_207_210)",
    fillOpacity: 0.03
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 104.706V106.8L7.65329e-05 106.8L7.66512e-05 104.706L1136.29 104.706Z",
    fill: "url(#paint45_linear_207_210)",
    fillOpacity: 0.03
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 356V358.094L6.23418e-05 358.094L6.24601e-05 356L1136.29 356Z",
    fill: "url(#paint46_linear_207_210)",
    fillOpacity: 0.03
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 272.235V274.329L6.70722e-05 274.329L6.71904e-05 272.235L1136.29 272.235Z",
    fill: "url(#paint47_linear_207_210)",
    fillOpacity: 0.03
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 523.529V525.624H5.2881e-05L5.29993e-05 523.529H1136.29Z",
    fill: "url(#paint48_linear_207_210)",
    fillOpacity: 0.03
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 20.9412V23.0353L8.12633e-05 23.0353L8.13816e-05 20.9412L1136.29 20.9412Z",
    fill: "url(#paint49_linear_207_210)",
    fillOpacity: 0.03
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 146.588V148.682L7.41678e-05 148.682L7.4286e-05 146.588L1136.29 146.588Z",
    fill: "url(#paint50_linear_207_210)",
    fillOpacity: 0.03
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 397.882V399.977L5.99766e-05 399.977L6.00949e-05 397.882L1136.29 397.882Z",
    fill: "url(#paint51_linear_207_210)",
    fillOpacity: 0.03
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 314.118V316.212L6.4707e-05 316.212L6.48252e-05 314.118L1136.29 314.118Z",
    fill: "url(#paint52_linear_207_210)",
    fillOpacity: 0.03
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 62.8236V64.9177L7.88981e-05 64.9176L7.90164e-05 62.8235L1136.29 62.8236Z",
    fill: "url(#paint53_linear_207_210)",
    fillOpacity: 0.03
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 188.471V190.565L7.18026e-05 190.565L7.19208e-05 188.471L1136.29 188.471Z",
    fill: "url(#paint54_linear_207_210)",
    fillOpacity: 0.03
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 439.765V441.859L5.76114e-05 441.859L5.77297e-05 439.765L1136.29 439.765Z",
    fill: "url(#paint55_linear_207_210)",
    fillOpacity: 0.03
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 251.294V253.388L6.82548e-05 253.388L6.8373e-05 251.294L1136.29 251.294Z",
    fill: "url(#paint56_linear_207_210)",
    fillOpacity: 0.03
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 502.588V504.682L5.40636e-05 504.682L5.41819e-05 502.588L1136.29 502.588Z",
    fill: "url(#paint57_linear_207_210)",
    fillOpacity: 0.03
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 3.84454e-05V2.09415H0L8.25642e-05 0L1136.29 3.84454e-05Z",
    fill: "url(#paint58_linear_207_210)",
    fillOpacity: 0.03
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 125.647V127.741L7.53504e-05 127.741L7.54686e-05 125.647L1136.29 125.647Z",
    fill: "url(#paint59_linear_207_210)",
    fillOpacity: 0.03
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 376.941V379.035L6.11592e-05 379.035L6.12775e-05 376.941L1136.29 376.941Z",
    fill: "url(#paint60_linear_207_210)",
    fillOpacity: 0.03
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 293.177V295.271L6.58896e-05 295.271L6.60078e-05 293.176L1136.29 293.177Z",
    fill: "url(#paint61_linear_207_210)",
    fillOpacity: 0.03
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 41.8824V43.9765L8.00807e-05 43.9765L8.0199e-05 41.8824L1136.29 41.8824Z",
    fill: "url(#paint62_linear_207_210)",
    fillOpacity: 0.03
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 167.529V169.624L7.29852e-05 169.624L7.31034e-05 167.529L1136.29 167.529Z",
    fill: "url(#paint63_linear_207_210)",
    fillOpacity: 0.03
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 418.824V420.918L5.8794e-05 420.918L5.89123e-05 418.824L1136.29 418.824Z",
    fill: "url(#paint64_linear_207_210)",
    fillOpacity: 0.03
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 335.059V337.153L6.35244e-05 337.153L6.36427e-05 335.059L1136.29 335.059Z",
    fill: "url(#paint65_linear_207_210)",
    fillOpacity: 0.03
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 83.7648V85.8589L7.77155e-05 85.8588L7.78338e-05 83.7647L1136.29 83.7648Z",
    fill: "url(#paint66_linear_207_210)",
    fillOpacity: 0.03
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 209.412V211.506L7.062e-05 211.506L7.07382e-05 209.412L1136.29 209.412Z",
    fill: "url(#paint67_linear_207_210)",
    fillOpacity: 0.03
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 460.706V462.8L5.64288e-05 462.8L5.65471e-05 460.706L1136.29 460.706Z",
    fill: "url(#paint68_linear_207_210)",
    fillOpacity: 0.03
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_207_210",
    x1: 569.5,
    y1: 0,
    x2: 569.5,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915623,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4451,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.a8d40d8de8ad473e84d8a8e4db70bd48.svg";
export { ForwardRef as ReactComponent };